module.exports = __webpack_public_path__ + "media/logos/layout-logo-compact-white-da52aff8.svg";